import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import { IconButton } from "@mui/material";
import usePagination from "@mui/material/usePagination";
import { white } from "designSystem/styles/color";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { styled } from "@mui/material/styles";

interface LBPaginationProps {
    count: number;
    children: React.ReactNode;
    updateViewablePage: (page: number) => void;
}

const PAGE_BTN_STYLES = {
	color: white[50],
	zIndex: 1,
	"& svg": {
		fontSize: 30,
		"&:hover, &:active": {
			color: white[50],
		},
	},
};

const PaginationButtonPrev = styled(IconButton)({
	...PAGE_BTN_STYLES,
});

const PaginationButtonNext = styled(IconButton)({
	...PAGE_BTN_STYLES,
	position: "absolute",
	right: 0,
});

const LBPagination: FunctionComponent<LBPaginationProps> = observer((props) => {
	const { count, updateViewablePage, children } = props;
	const { items } = usePagination({
		count,
		onChange: (event, currPage) => {
			const page = Math.abs((currPage % count));
			updateViewablePage(page);
		},
	});

	return (
		<>
			{count > 1 && items.map(({ page, type, selected, disabled, ...item }, index) => {
				if (type === "previous") {
					return (
						<PaginationButtonPrev key={index} {...item}>
							<KeyboardArrowLeft />
						</PaginationButtonPrev>
					);
				} else if (type === "next") {
					disabled = false;
					return (
						<PaginationButtonNext key={index} {...item}>
							<KeyboardArrowRight />
						</PaginationButtonNext>
					);
				}
			})}
			{children}
		</>
	);
});

export default LBPagination;